// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xBQc-","title":"styles_title__1pks1"};